import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ErrorHandler from 'common/error/components/error-handler';
import { withRouter } from 'utils/withRouter';
import useDeepCompareEffect from 'use-deep-compare-effect';
import SearchResultTypeComponent from '../../components/type/search-type-results';
import { searchByType as searchAction, clearSearch as clearSearchAction } from '../search-actions';
import performSearch from '../../helper';

const SearchResults = ({
  searchByType,
  clearSearch,
  results,
  isLoading,
  activePage,
  error,
  shouldRefetch,
  searchFilters = {},
  match,
  history,
  location,
}) => {
  const search = () => {
    const page = match.params.page || 1;
    performSearch({ ...match.params, page }, searchByType, searchFilters, location);
  };

  useEffect(() => () => {
    clearSearch();
  }, []);

  useEffect(() => {
    if (shouldRefetch) {
      search();
    }
  }, [shouldRefetch]);

  useDeepCompareEffect(() => {
    const qParams = location.state;
    if (qParams?.searchFilters && Object.keys(searchFilters).length && Object.keys(match.params)) {
      search();
    }
  }, [searchFilters]);

  useDeepCompareEffect(() => {
    const qParams = location.state;
    if (
      ((!qParams?.searchFilters && !Object.keys(searchFilters).length) ||
        Object.keys(searchFilters).length) &&
      Object.keys(match.params)) {
      search();
    }
  }, [match.params]);

  const changePage = (page) => {
    const { searchValue, type, relationId } = match.params;
    const qParams = location.state;
    const queryString = qParams?.searchFilters;

    history.push(
      // eslint-disable-next-line
      `/search/${encodeURIComponent(searchValue)}/type/${type}/page/${page}${relationId ? `/relations/${relationId}` : ''}`,
      {
        searchFilters: queryString || '',
      },
    );
  };

  return (
    <>
      <ErrorHandler type='notification' error={error} />
      <SearchResultTypeComponent
        type={match.params.type}
        results={results}
        activePage={activePage}
        changePage={changePage}
        isLoading={isLoading}
      />
    </>
  );
};

SearchResults.propTypes = {
  searchByType: PropTypes.func.isRequired,
  clearSearch: PropTypes.func.isRequired,
  results: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  activePage: PropTypes.number.isRequired,
  error: PropTypes.object,
  shouldRefetch: PropTypes.bool,
  searchFilters: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
};

const mapStateToProps = state => ({
  searchValue: state.search.searchValue,
  results: state.search.type.results,
  isLoading: state.search.type.isLoading,
  error: state.search.type.error,
  activePage: state.search.type.activePage,
  shouldRefetch: state.search.type.shouldRefetch,
  searchFilters: state.search.searchFilters,
  fetchFiltersSuccess: state.search.fetchFiltersSuccess,
});

const mapDispatchToProps = { searchByType: searchAction, clearSearch: clearSearchAction };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SearchResults));
